<!-- рекурсивный компонент для визуализации дерева -->
<template>
    <div :class="nodeClass">
        <div v-if="!rootNode" class="node-view-line" >
            <span v-if="isNodeExpandable"
                  id="expandSignId"
                  ref="expandSignId"
                  class="node-view-line-expander"
                  @click="$emit('expand-node', nodeDescription)">
                {{node.value.isExpanded ? '–' : '+'}}
            </span>
            <HighLightedCheckBox
                 :nodeValue="node.value"
                 :searchText="searchText"
                 :mode="{highlight}"
                 :styled="isNodeFullyChosen ? {styleType: 'bold'} : {}"
                 @choose-node="choose"
            />
        </div>

        <ul v-if="acceptChildrenMounting" :class="ulClass">
            <Node v-for="(child, index) in node.children"
                  :key="index"
                  :node="child"
                  :expandable="expandable"
                  :highlight="highlight"
                  :searchText="searchText"
                  :withImportantNodes="withImportantNodes"
                  @expand-node="expand"
                  @choose-node="choose"
            />
        </ul>
    </div>
</template>

<script>
    import HighLightedCheckBox from 'highlighted-checkbox';
    import NodeStructure from "../data_structures/Node";

    export default {
        name: "Node",
        components: {HighLightedCheckBox},
        props: {
            node: {
                type: NodeStructure,
                required: true,
            },
            expandable: {
                type: Boolean,
                default: true,
            },
            highlight: {
                type: Boolean,
                default: true,
            },
            searchText: {
                type: String,
                default: '',
            },
            withImportantNodes: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            rootNode() {
                return (this.node.value.nodeLevel === 0);
            },
            isNodeExpandable() {
                return (this.node.children.length > 0 && this.expandable);
            },
            nodeDescription() {
                return {
                    level: this.node.value.nodeLevel,
                    id: this.node.value.obj.id
                };
            },
            isNodeFullyChosen() {
                return (this.node.value.isChosen && !this.node.value.isPartiallyChosen);
            },
            acceptChildrenMounting() {
                return (this.node.value.isExpanded && this.node.children.length > 0);
            },
            nodeClass() {
                return {
                    'node-important': (this.withImportantNodes && this.node.value.obj.important),
                };
            },
            ulClass() {
                return {
                    'tree-ul': true,
                    'tree-ul-root': this.rootNode,
                };
            },
        },

        methods: {
            expand (nodeDescription) {
                this.$emit('expand-node', nodeDescription);
            },
            choose (nodeDescription) {
                this.$emit('choose-node', nodeDescription);
            }
        },
    }
</script>

<style scoped src="./Node.css">
</style>
